module.exports = __webpack_public_path__ + "static/media/tc.98d2c064.svg";